import { ReactNodeViewRenderer as d } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { BLOCK_IMAGE_STYLES as A, FIGCAPTION_STYLES as T, FIGURE_CENTERED_STYLES as _, getFigureRightStyles as C, FIGURE_MOBILE_FULL_WIDTH_STYLES as M } from "../../constants/default-styles.mjs";
import { ImageNameEnum as F, ImageModeEnum as g } from "./image-enum.mjs";
import { convertStyleObjectToCss as l } from "../../utils/style-helpers.mjs";
import { CustomImage as B } from "./custom-image.mjs";
import { Image as R } from "./image.mjs";
import { getContainerWidthFromElement as b } from "./utils/get-container-width-from-element.mjs";
import { getImageAttrs as k } from "./utils/get-image-attrs.mjs";
import { getImageWithLinkHtml as E } from "./utils/get-image-with-link-html.mjs";
import { MOBILE_FULL_WIDTH_CLASSNAME as S } from "./constants/index.mjs";
import { mergeAttributes as h } from "../../node_modules/@tiptap/core/dist/index.mjs";
const j = R.extend({
  name: F.Block,
  addNodeView() {
    return d(B);
  },
  parseHTML() {
    return [
      {
        // skip ckeditor's legacy - tables https://app.shortcut.com/systeme/story/53281/he-has-a-problem-with-one-of-his-campaigns-in-the-classic-editor-where-he-can-no-longer-find-the-content-of-his-emails
        tag: "figure:not(.table)",
        getAttrs: (t) => {
          const m = t.querySelector("img"), o = t.querySelector("a"), r = t.querySelector("figcaption"), a = o == null ? void 0 : o.getAttribute("href"), c = k(m), s = b(t), i = !!t.closest(`div.${S}`);
          return {
            imageMode: t != null && t.style.float ? g.BlockRight : g.BlockCenter,
            href: a,
            containerWidth: s,
            caption: r == null ? void 0 : r.textContent,
            isMobileFullWidth: i,
            ...c
          };
        }
      }
    ];
  },
  renderHTML({
    HTMLAttributes: {
      caption: t,
      href: m,
      imageMode: o,
      alt: r,
      src: a,
      title: c,
      width: s,
      height: i,
      containerWidth: e,
      uploadingProps: u,
      isMobileFullWidth: L
    }
  }) {
    if (u) return ["span", { style: "display: none;" }];
    const n = { ...A };
    s && i && (n.aspectRatio = `${s}/${i}`), e !== "auto" && (n.width = e);
    const y = h({
      src: a,
      alt: r,
      title: c,
      width: s,
      style: l(n)
    }), f = [E(y, { href: m })];
    t && f.push([
      "figcaption",
      {
        style: l(T)
      },
      t
    ]);
    const I = o === g.BlockCenter ? {
      ..._,
      ...e && { width: e }
    } : {
      ...C(!1),
      ...e && { width: e }
    }, p = ["figure", {
      style: l(I)
    }, ...f];
    return L ? [
      "div",
      { class: S },
      ["head", {}, ["style", { type: "text/css" }, M]],
      p
    ] : p;
  }
});
export {
  j as BlockImage
};
